import * as G from 'ApplicationEntry/models/ProductsRiders/UniversalLife/GroupUL';
import * as NY from 'ApplicationEntry/models/ProductsRiders/UniversalLife/NewYorkUL';
import * as O from 'ApplicationEntry/models/ProductsRiders/UniversalLife/OrdinaryUL';
import {matchULByType, UniversalLife} from 'ApplicationEntry/models/ProductsRiders/UniversalLife/UniversalLife';
import {Async, Loading} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

export enum ULActionType {
  CHANGE_PLAN = 'ul/CHANGE_PLAN',
  CHANGE_PREMIUM = 'ul/CHANGE_PREMIUM',
  CHANGE_CALCULATED_PREMIUM = 'ul/CHANGE_CALCULATED_PREMIUM',
  CHANGE_CWA = 'ul/CHANGE_CWA',
  CHANGE_SITUS_STATE = 'ul/CHANGE_SITUS_STATE',
  CHANGE_TYPE = 'ul/CHANGE_TYPE',
  CHANGE_FACE_AMT = 'ul/CHANGE_FACE_AMT',
  CHANGE_POLICY_NUM = 'ul/CHANGE_POLICY_NUM',
  CHANGE_PREMIUM_TYPE = 'ul/CHANGE_PREMIUM_TYPE',
  CHANGE_PRI_INSURED = 'ul/CHANGE_PRI_INSURED',
  CHANGE_SPOUSE_INSURED = 'ul/CHANGE_SPOUSE_INSURED',
  CHANGE_AUTO_ISSUE_ELIGIBILTY = 'ul/CHANGE_AUTO_ISSUE_ELIGIBILTY',
  CHANGE_REPLACEMENT = 'ul/CHANGE_REPLACEMENT',
  CHANGE_RIDER_CODES = 'ul/CHANGE_RIDER_CODES',
  CHANGE_RIDER_AMTS = 'ul/CHANGE_RIDER_AMTS',
  CHANGE_COMMISSION = 'ul/CHANGE_COMMISSION',
  CHANGE_DEATH_BENEFIT = 'ul/CHANGE_DEATH_BENEFIT',
  CHANGE_ADB = 'ul/CHANGE_ADB',
  CHANGE_SB_VOLUME = 'ul/CHANGE_SB_VOLUME',
  CHANGE_WAIVER = 'ul/CHANGE_WAIVER',
  CHANGE_STRIKE_LAYOFF = 'ul/CHANGE_STRIKE_LAYOFF',
  CHANGE_GUAC = 'ul/CHANGE_GUAC',
  CHANGE_GULBR = 'ul/CHANGE_GULBR',
  CHANGE_GULTC = 'ul/CHANGE_GULTC',
  CHANGE_GULTCEXT = 'ul/CHANGE_GULTCEXT',
  CHANGE_CHRONIC_ILLNESS = 'ul/CHANGE_CHRONIC_ILLNESS',
  CHANGE_PRODUCT = 'ul/CHANGE_PRODUCT',
  CHANGE_JSTAMP = 'ul/CHANGE_JSTAMP',
  CHANGE_PACKAGE_NAME = 'ul/CHANGE_PACKAGE_NAME',
  GET_PACKAGE_LIST = 'ul/GET_PACKAGE_LIST',
  CHANGE_PACKAGE_LIST = 'ul/CHANGE_PACKAGE_LIST',
  RESET_SPOUSE_INSURED = 'ul/RESET_SPOUSE_INSURED',
  CHANGE_PACKAGE_ITEM = 'ul/CHANGE_PACKAGE_ITEM',
  CLEAR_UNIVERSAL_LIFE = 'ul/CLEAR_UNIVERSAL_LIFE',
  CHANGE_RIDER_INFORMATION = 'ul/CHANGE_RIDER_INFORMATION',
}

export const isULAction = (action: any): action is ULAction => action.type in reverseEnum(ULActionType);

export const changePlan = (plan: string) => createAction(ULActionType.CHANGE_PLAN, {plan});
export const changePremium = (premium: string) => createAction(ULActionType.CHANGE_PREMIUM, {premium});
export const changeCalculatedPremium = (calculatedPremium: string) =>
  createAction(ULActionType.CHANGE_CALCULATED_PREMIUM, {calculatedPremium});
export const changeCWA = (cwa: string) => createAction(ULActionType.CHANGE_CWA, {cwa});
export const changeSitusState = (state: string) => createAction(ULActionType.CHANGE_SITUS_STATE, {state});
export const changeType = (type: string) => createAction(ULActionType.CHANGE_TYPE, {type});
export const changeFaceAmt = (amt: string) => createAction(ULActionType.CHANGE_FACE_AMT, {amt});
export const changePolicyNum = (polNumber: string) => createAction(ULActionType.CHANGE_POLICY_NUM, {polNumber});
export const changePriInsured = (insured: string) => createAction(ULActionType.CHANGE_PRI_INSURED, {insured});
export const changeSpouseInsured = (insured: string) => createAction(ULActionType.CHANGE_SPOUSE_INSURED, {insured});
export const changePremiumType = (type: string) => createAction(ULActionType.CHANGE_PREMIUM_TYPE, {type});
export const changeEligibility = (eligibility: boolean) =>
  createAction(ULActionType.CHANGE_AUTO_ISSUE_ELIGIBILTY, {eligibility});
export const changeReplacement = (replacement: boolean) => createAction(ULActionType.CHANGE_REPLACEMENT, {replacement});
export const changeRiderCodes = (riderCode: string, index: number) =>
  createAction(ULActionType.CHANGE_RIDER_CODES, {riderCode, index});
export const changeRiderAmts = (riderAmt: number, index: number) =>
  createAction(ULActionType.CHANGE_RIDER_AMTS, {riderAmt, index});
export const changeCommission = (commission: string) => createAction(ULActionType.CHANGE_COMMISSION, {commission});
export const changeDeathBenefit = (deathBenefit: string) =>
  createAction(ULActionType.CHANGE_DEATH_BENEFIT, {deathBenefit});
export const changeSBVolume = (vol: string) => createAction(ULActionType.CHANGE_SB_VOLUME, {vol});
export const changeChronicIllness = (illness: string) => createAction(ULActionType.CHANGE_CHRONIC_ILLNESS, {illness});
export const changeADB = (adb: boolean) => createAction(ULActionType.CHANGE_ADB, {adb});
export const changeWaiver = (waiver: boolean) => createAction(ULActionType.CHANGE_WAIVER, {waiver});
export const changeStrikeLayoff = (layoff: boolean) => createAction(ULActionType.CHANGE_STRIKE_LAYOFF, {layoff});
export const changeGUAC = (guac: boolean) => createAction(ULActionType.CHANGE_GUAC, {guac});
export const changeGULBR = (gulbr: boolean) => createAction(ULActionType.CHANGE_GULBR, {gulbr});
export const changeGULTC = (gultc: boolean) => createAction(ULActionType.CHANGE_GULTC, {gultc});
export const changeGULTCEXT = (gultcext: boolean) => createAction(ULActionType.CHANGE_GULTCEXT, {gultcext});
export const changeProduct = (product: string) => createAction(ULActionType.CHANGE_PRODUCT, {product});
export const changeJStamp = (stamp: boolean) => createAction(ULActionType.CHANGE_JSTAMP, {stamp});
export const changePackageName = (packageName: string) => createAction(ULActionType.CHANGE_PACKAGE_NAME, {packageName});
export const changePackageList = (packages: Async<object[]>) =>
  createAction(ULActionType.CHANGE_PACKAGE_LIST, {packages});
export const getPackageList = (caseNumber: string, planCode: string) =>
  createAction(ULActionType.GET_PACKAGE_LIST, {caseNumber, planCode});
export const resetSpouseInsured = () => createAction(ULActionType.RESET_SPOUSE_INSURED);
export const changePackageItem = (packageItem: object) => createAction(ULActionType.CHANGE_PACKAGE_ITEM, {packageItem});
export const clearUniversalLife = () => createAction(ULActionType.CLEAR_UNIVERSAL_LIFE);
export const changeRiderInformation = (amount: number, code: string, index: number) =>
  createAction(ULActionType.CHANGE_RIDER_INFORMATION, {amount, code, index});

export type ULAction =
  | ReturnType<typeof changePlan>
  | ReturnType<typeof changePremium>
  | ReturnType<typeof changeCalculatedPremium>
  | ReturnType<typeof changeCWA>
  | ReturnType<typeof changeSitusState>
  | ReturnType<typeof changeType>
  | ReturnType<typeof changeFaceAmt>
  | ReturnType<typeof changePolicyNum>
  | ReturnType<typeof changePriInsured>
  | ReturnType<typeof changeSpouseInsured>
  | ReturnType<typeof changePremiumType>
  | ReturnType<typeof changeEligibility>
  | ReturnType<typeof changeReplacement>
  | ReturnType<typeof changeRiderCodes>
  | ReturnType<typeof changeRiderAmts>
  | ReturnType<typeof changeCommission>
  | ReturnType<typeof changeDeathBenefit>
  | ReturnType<typeof changeSBVolume>
  | ReturnType<typeof changeChronicIllness>
  | ReturnType<typeof changeADB>
  | ReturnType<typeof changeWaiver>
  | ReturnType<typeof changeStrikeLayoff>
  | ReturnType<typeof changeGUAC>
  | ReturnType<typeof changeGULBR>
  | ReturnType<typeof changeGULTC>
  | ReturnType<typeof changeGULTCEXT>
  | ReturnType<typeof changeProduct>
  | ReturnType<typeof changeJStamp>
  | ReturnType<typeof changePackageName>
  | ReturnType<typeof changePackageList>
  | ReturnType<typeof getPackageList>
  | ReturnType<typeof resetSpouseInsured>
  | ReturnType<typeof changeRiderInformation>
  | ReturnType<typeof changePackageItem>
  | ReturnType<typeof clearUniversalLife>;

type ULState = UniversalLife;

export default (state: ULState, action: ULAction): ULState => {
  switch (action.type) {
    case ULActionType.CHANGE_PLAN:
      return matchULByType<UniversalLife>({
        Ordinary: O.changePlan(action.payload.plan),
        Group: G.changePlan(action.payload.plan),
        NewYork: NY.changePlan(action.payload.plan),
      })(state);
    case ULActionType.CHANGE_PREMIUM:
      return matchULByType<UniversalLife>({
        Ordinary: O.changePremium(action.payload.premium),
        Group: G.changePremium(action.payload.premium),
        NewYork: NY.changePremium(action.payload.premium),
      })(state);
    case ULActionType.CHANGE_CALCULATED_PREMIUM:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeCalculatedPremium(action.payload.calculatedPremium),
        Group: G.changeCalculatedPremium(action.payload.calculatedPremium),
        NewYork: NY.changeCalculatedPremium(action.payload.calculatedPremium),
      })(state);
    case ULActionType.CHANGE_CWA:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeCWA(action.payload.cwa),
        Group: G.changeCWA(action.payload.cwa),
        NewYork: NY.changeCWA(action.payload.cwa),
      })(state);
    case ULActionType.CHANGE_SITUS_STATE:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeSitusState(action.payload.state),
        Group: G.changeSitusState(action.payload.state),
        NewYork: NY.changeSitusState(action.payload.state),
      })(state);
    case ULActionType.CHANGE_TYPE:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeType(action.payload.type),
        Group: G.changeType(action.payload.type),
        NewYork: NY.changeType(action.payload.type),
      })(state);
    case ULActionType.CHANGE_FACE_AMT:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeFaceAmt(action.payload.amt),
        Group: G.changeFaceAmt(action.payload.amt),
        NewYork: NY.changeFaceAmt(action.payload.amt),
      })(state);
    case ULActionType.CHANGE_POLICY_NUM:
      return matchULByType<UniversalLife>({
        Ordinary: O.changePolicyNumber(action.payload.polNumber),
        Group: G.changePolicyNumber(action.payload.polNumber),
        NewYork: NY.changePolicyNumber(action.payload.polNumber),
      })(state);
    case ULActionType.CHANGE_PREMIUM_TYPE:
      return matchULByType<UniversalLife>({
        Ordinary: O.changePremiumType(action.payload.type),
        Group: G.changePremiumType(action.payload.type),
        NewYork: NY.changePremiumType(action.payload.type),
      })(state);
    case ULActionType.CHANGE_PRI_INSURED:
      return matchULByType<UniversalLife>({
        Ordinary: O.changePriInsured(action.payload.insured),
        Group: G.changePriInsured(action.payload.insured),
        NewYork: NY.changePriInsured(action.payload.insured),
      })(state);
    case ULActionType.CHANGE_SPOUSE_INSURED:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeSpouseInsured(action.payload.insured),
        Group: G.changeSpouseInsured(action.payload.insured),
        NewYork: NY.changeSpouseInsured(action.payload.insured),
      })(state);
    case ULActionType.CHANGE_AUTO_ISSUE_ELIGIBILTY:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeAutoIssue(action.payload.eligibility),
        Group: G.changeAutoIssue(action.payload.eligibility),
        NewYork: NY.changeAutoIssue(action.payload.eligibility),
      })(state);
    case ULActionType.CHANGE_REPLACEMENT:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeReplacement(action.payload.replacement),
        Group: G.changeReplacement(action.payload.replacement),
        NewYork: NY.changeReplacement(action.payload.replacement),
      })(state);
    case ULActionType.CHANGE_RIDER_CODES:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeRiderCodes(action.payload.riderCode, action.payload.index),
        NewYork: NY.changeRiderCodes(action.payload.riderCode, action.payload.index),
        _: () => state,
      })(state);
    case ULActionType.CHANGE_RIDER_AMTS:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeRiderAmount(action.payload.riderAmt, action.payload.index),
        NewYork: NY.changeRiderAmount(action.payload.riderAmt, action.payload.index),
        _: () => state,
      })(state);
    case ULActionType.CHANGE_COMMISSION:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeCommision(action.payload.commission),
        Group: G.changeCommision(action.payload.commission),
        NewYork: NY.changeCommision(action.payload.commission),
      })(state);
    case ULActionType.CHANGE_DEATH_BENEFIT:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeDeathBenefit(action.payload.deathBenefit),
        Group: G.changeDeathBenefit(action.payload.deathBenefit),
        NewYork: NY.changeDeathBenefit(action.payload.deathBenefit),
      })(state);
    case ULActionType.CHANGE_SB_VOLUME:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeSBVolume(action.payload.vol),
        Group: G.changeSBVolume(action.payload.vol),
        NewYork: NY.changeSBVolume(action.payload.vol),
      })(state);
    case ULActionType.CHANGE_CHRONIC_ILLNESS:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeChronicIllness(action.payload.illness),
        Group: G.changeChronicIllness(action.payload.illness),
        NewYork: NY.changeChronicIllness(action.payload.illness),
      })(state);
    case ULActionType.CHANGE_ADB:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeADB(action.payload.adb),
        Group: G.changeADB(action.payload.adb),
        NewYork: NY.changeADB(action.payload.adb),
      })(state);
    case ULActionType.CHANGE_WAIVER:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeWaiver(action.payload.waiver),
        Group: G.changeWaiver(action.payload.waiver),
        NewYork: NY.changeWaiver(action.payload.waiver),
      })(state);
    case ULActionType.CHANGE_STRIKE_LAYOFF:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeStrikeLayOff(action.payload.layoff),
        Group: G.changeStrikeLayOff(action.payload.layoff),
        NewYork: NY.changeStrikeLayOff(action.payload.layoff),
      })(state);
    case ULActionType.CHANGE_GUAC:
      return matchULByType<UniversalLife>({
        Ordinary: O.changeGUAC(action.payload.guac),
        Group: G.changeGUAC(action.payload.guac),
        NewYork: NY.changeGUAC(action.payload.guac),
      })(state);
    case ULActionType.CHANGE_GULBR:
      return matchULByType<UniversalLife>({
        Group: G.changeGULBR(action.payload.gulbr),
        _: () => state,
      })(state);
    case ULActionType.CHANGE_GULTC:
      return matchULByType<UniversalLife>({
        Group: G.changeGULTC(action.payload.gultc),
        _: () => state,
      })(state);
    case ULActionType.CHANGE_GULTCEXT:
      return matchULByType<UniversalLife>({
        Group: G.changeGULTCEXT(action.payload.gultcext),
        _: () => state,
      })(state);
    case ULActionType.CHANGE_PRODUCT:
      return matchULByType<UniversalLife>({
        Ordinary: () => state,
        Group: G.changeproduct(action.payload.product),
        NewYork: () => state,
      })(state);
    case ULActionType.CHANGE_JSTAMP:
      return matchULByType<UniversalLife>({
        Ordinary: () => state,
        Group: G.changeJStamp(action.payload.stamp),
        NewYork: () => state,
      })(state);
    case ULActionType.CHANGE_PACKAGE_NAME:
      return matchULByType<UniversalLife>({
        Ordinary: () => state,
        Group: G.changePackageName(action.payload.packageName),
        NewYork: () => state,
      })(state);
    case ULActionType.GET_PACKAGE_LIST:
      return matchULByType<UniversalLife>({
        Ordinary: () => state,
        Group: G.changePackageList(new Loading()),
        NewYork: () => state,
      })(state);
    case ULActionType.CHANGE_PACKAGE_LIST:
      return matchULByType<UniversalLife>({
        Ordinary: () => state,
        Group: G.changePackageList(action.payload.packages),
        NewYork: () => state,
      })(state);
    case ULActionType.CHANGE_PACKAGE_ITEM:
      return matchULByType<UniversalLife>({
        Ordinary: () => state,
        Group: G.changePackageItem(action.payload.packageItem),
        NewYork: () => state,
      })(state);
    case ULActionType.RESET_SPOUSE_INSURED:
      return matchULByType<UniversalLife>({
        Ordinary: () => state,
        Group: G.resetSpouseInsured(),
        NewYork: () => state,
      })(state);
    case ULActionType.CHANGE_RIDER_INFORMATION:
      return matchULByType<UniversalLife>({
        Group: G.changeRiderInformation(action.payload.amount, action.payload.code, action.payload.index),
        _: () => state,
      })(state);
    case ULActionType.CLEAR_UNIVERSAL_LIFE:
      if (state.key === 'InvalidGroupUL' || state.key === 'ValidGroupUL') {
        return G.EmptyGroupUL;
      } else if (state.key === 'InvalidNewYorkUL' || state.key === 'ValidNewYorkUL') {
        return NY.EmptyNewYorkUL;
      } else if (state.key === 'InvalidOrdUL' || state.key === 'ValidOrdUL') {
        return O.EmptyOrdUL;
      }

      return state;
    default:
      return state;
  }
};
